import { registerPlugin } from '@capacitor/core';
import { isNativePlatform } from './device';

const BlobDownload = registerPlugin('BlobDownload');

function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const result = reader.result;
      if (typeof result !== 'string') {
        reject(new Error('Failed to read file data'));
        return;
      }
      const comma = result.indexOf(',');
      resolve(comma >= 0 ? result.slice(comma + 1) : result);
    };
    reader.onerror = () => reject(reader.error || new Error('Failed to read file data'));
    reader.readAsDataURL(blob);
  });
}

export async function saveBlobToDownloads(blob, filename) {
  if (!isNativePlatform()) {
    throw new Error('Native download is only available in the mobile app');
  }

  const base64 = await blobToBase64(blob);
  const mimeType = blob.type || 'application/octet-stream';

  return BlobDownload.saveToDownloads({
    filename,
    base64,
    mimeType,
  });
}
